export enum TopologyTooltipsTypes {
  SingleDeviceTooltip = "Single Device Tooltip",
  SingleClientTooltip = "Single Client tooltip",
  MultiClientTooltip = "Multi Client tooltip",
  FailedClientsTooltip = "Failed Clients Tooltip",
  CloudeNodeTooltip = 'Cloude Node Tooltip'
}
